import { useContrastQuery } from '../../../../hooks/use-contrast-query'
import { LatestUsedCredentials } from './shared'
import {
  getLatestUsedCredentials,
  GetLatestUsedCredentialsArgs
} from './requests/get-latest-credentials'
import { Query } from '../../../../hooks/queries'
import { HTTPError } from '../../../../api/fetch/decorate-fetch'
import { updateAnyState } from '../../jira/jira-integration-page/state/jira-integration-page.state'
import { JiraFormFieldTypes } from '../../jira/jira-integration-page/jira-form-field-types'

export interface UseLatestUsedCredentialsQueryProps {
  organizationUuid: string
  bugtracker: 'JIRA' | 'AGILE_CENTRAL'
  updateFormValue: (key: string, value: any) => void
  successCallback: (LatestUsedCredentials) => void
  disabled?: boolean
}

export interface LatestUsedCredentialsResponse {
  credentials: LatestUsedCredentials | undefined
  error: HTTPError | null
  isError: boolean
  isLoading: boolean
}

export type UseLatestUsedCredentialsQuery = (
  props: UseLatestUsedCredentialsQueryProps
) => LatestUsedCredentialsResponse

/** This returns the latest credentials but ALSO sets the credentials_id in the form */
export const useLatestUsedCredentialsQuery: UseLatestUsedCredentialsQuery = ({
  organizationUuid,
  bugtracker,
  updateFormValue,
  successCallback,
  disabled = false
}: UseLatestUsedCredentialsQueryProps) => {
  const {
    data: credentials,
    error,
    isError,
    isLoading
  } = useContrastQuery<GetLatestUsedCredentialsArgs, LatestUsedCredentials>(
    [Query.INTEGRATIONS_LATEST_CREDENTIALS, organizationUuid, bugtracker],
    getLatestUsedCredentials,
    {
      organizationUuid,
      bugtracker
    },
    {
      enabled: !disabled,
      cacheTime: 0,
      onSuccess: (data) => {
        if (!data) {
          //  TODO: Is this a bug? Does it need to be wrapped in the `dispatch` function similar to other calls?
          updateAnyState({
            credentials: null,
            previousSavedCredentialsName: null
          })
          return
        }
        updateFormValue(JiraFormFieldTypes.CREDENTIALS_HOST, data.host)
        updateFormValue(JiraFormFieldTypes.CREDENTIALS_ID, data.id)
        updateFormValue(JiraFormFieldTypes.CREDENTIALS_USERNAME, data.username)
        updateFormValue(JiraFormFieldTypes.CREDENTIALS_NAME, data.name)

        successCallback(data)
      }
    }
  )

  return {
    credentials,
    error,
    isError,
    isLoading
  }
}
